import Vue from "vue";
import VueRouter from "vue-router";
import Proton from "../views/Proton.vue";
import Radiation from "../views/Radiation.vue";
import Technology from "../views/Technology.vue";
import Adaptive from "../views/Adaptive.vue";
import AD01 from "../views/Adaptive/AD01.vue";
import AD02 from "../views/Adaptive/AD02.vue";
import About from "../views/Abouts.vue";
import Home from "../views/Home.vue";
import A01 from "../views/About/A01.vue";
import A0101 from "../views/About/A0101.vue";
import A0102 from "../views/About/A0102.vue";
import A0103 from "../views/About/A0103.vue";
import A0104 from "../views/About/A0104.vue";
import A02 from "../views/About/A02.vue";
import A03 from "../views/About/A03.vue";
import T01 from "../views/Technology/T01.vue";
import T02 from "../views/Technology/T02.vue";
import T03 from "../views/Technology/T03.vue";
import T04 from "../views/Technology/T04.vue";
import T05 from "../views/Adaptive/T05.vue";
import T06 from "../views/Adaptive/T06.vue";
import T07 from "../views/Technology/T07.vue";
import R01 from "../views/Radiation/R01.vue";
import R02 from "../views/Technology/R02.vue";
import R03 from "../views/Radiation/R03.vue";
import R04 from "../views/Radiation/R04.vue";
import R05 from "../views/Radiation/R05.vue";
import R06 from "../views/Radiation/R06.vue";
import R07 from "../views/Radiation/R07.vue";
import P01 from "../views/Proton/P01.vue";
import P02 from "../views/Proton/P02.vue";
import P03 from "../views/Proton/P03.vue";
import P04 from "../views/Proton/P04.vue";
import P05 from "../views/Proton/P05.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/Home", name: "Home", component: Home },
  { path: "/Radiation", name: "Radiation", component: Radiation },
  {
    path: "/R01",
    name: "R01",
    component: R01
  },
  {
    path: "/R02",
    name: "R02",
    component: R02
  },
  {
    path: "/R03",
    name: "R03",
    component: R03
  },
  {
    path: "/R04",
    name: "R04",
    component: R04
  },
  {
    path: "/R05",
    name: "R05",
    component: R05
  },
  {
    path: "/R06",
    name: "R06",
    component: R06
  },
  {
    path: "/R07",
    name: "R07",
    component: R07
  },
  {
    path: "/Technology",
    name: "Technology",
    component: Technology
  },

  {
    path: "/T01",
    name: "T01",
    component: T01
  },
  {
    path: "/T02",
    name: "T02",
    component: T02
  },
  {
    path: "/T03",
    name: "T03",
    component: T03
  },
  {
    path: "/T04",
    name: "T04",
    component: T04
  },
  {
    path: "/T05",
    name: "T05",
    component: T05
  },
  {
    path: "/T06",
    name: "T06",
    component: T06
  },

  {
    path: "/T07",
    name: "T07",
    component: T07
  },

  { path: "/About", name: "About", component: About },
  {
    path: "/A01",
    name: "A01",
    component: A01
  },
  {
    path: "/A0101",
    name: "A0101",
    component: A0101
  },
  {
    path: "/A0102",
    name: "A0102",
    component: A0102
  },
  {
    path: "/A0103",
    name: "A0103",
    component: A0103
  },
  {
    path: "/A0104",
    name: "A0104",
    component: A0104
  },
  {
    path: "/A02",
    name: "A02",
    component: A02
  },
  {
    path: "/A03",
    name: "A03",
    component: A03
  },
  {
    path: "/AD01",
    name: "AD01",
    component: AD01
  },
  {
    path: "/AD02",
    name: "AD02",
    component: AD02
  },
  {
    path: "/Adaptive",
    name: "Adaptive",
    component: Adaptive
  },
  {
    path: "/Proton",
    name: "Proton",
    component: Proton
  },

  {
    path: "/P01",
    name: "P01",
    component: P01
  },
  {
    path: "/P02",
    name: "P02",
    component: P02
  },
  {
    path: "/P03",
    name: "P03",
    component: P03
  },
  {
    path: "/P04",
    name: "P04",
    component: P04
  },
  {
    path: "/P05",
    name: "P05",
    component: P05
  },
  {
    path: "/about",
    name: "about",
    component: About
  },
  { path: "/*", redirect: "/home" }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
